// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"UsuarioAsignar_spinnerContainer__FyoHZ","botonAdd":"UsuarioAsignar_botonAdd__zANO1"};